// 

import { getDataSet } from '../lib/dataset';

let configureActionsInternal;

export const executeWebAction = (action, payload, event) => {
  if (!configureActionsInternal) {
    throw new Error('Akce nejsou nastavené. Zavolejte funkci connectWebActions');
  }
  configureActionsInternal(action)(payload, event);
};

const handleActionEvent = (e) => {
  const closest = e.target.closest ? e.target.closest(`[data-action][data-action-trigger="${e.type}"]`) : null;
  if (!closest) {
    return;
  }
  const dataset = getDataSet(closest);
  const { action } = dataset;
  executeWebAction(action, dataset, e);
};

/**
 * Připojí na document listener na elementy, které mají na sobě data atributy data-action a data-action-trigger
 * Atributem data-action-trigger je definováno při jakém eventu se akce vykoná
 * Atributem data-action je definováno jaká akce se vykoná
 * Všechny data attributy jsou předány jako payload vykonávané akci
 * Je nasloucháno pouze na eventy 'click' a 'partialUpdateComplete', pokud
 * potřebujete naslouchat i na jiné eventy, tak je defitujte do parametru customEvents
 *
 */
export default (configureActions, customEvents = []) => {
  configureActionsInternal = configureActions;
  const events = [
    // 'focus',
    // 'blur',
    // 'reset',
    // 'submit',
    // 'keydown',
    // 'keypress',
    // 'keyup',
    // 'mouseenter',
    // 'mouseover',
    // 'mousemove',
    // 'mousedown',
    // 'mouseup',
    // 'auxclick',
    'click',
    // 'change',
    // 'dblclick',
    // 'contextmenu',
    // 'wheel',
    // 'mouseleave',
    // 'mouseout',
    // 'select',
    // 'dragstart',
    // 'drag',
    // 'dragend',
    // 'dragenter',
    // 'dragover',
    // 'dragleave',
    // 'drop',
    // Partial update
    'partialUpdateComplete',
    ...customEvents,
  ];
  events.forEach((event) => {
    document.addEventListener(event, handleActionEvent);
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/webComponents/connectWebActions.js